import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useIsAdmin() {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(
    location.pathname.startsWith("/admin/dashboard")
  );

  useEffect(() => {
    setIsAdmin(location.pathname.startsWith("/admin/dashboard"));
  }, [location]);

  return isAdmin;
}
